var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272 272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.05,184.38,65.19,121.51a8.49,8.49,0,1,1,12-12l46.39,46.41c14.21-24.64,55-85.75,120.2-106.49A8.5,8.5,0,0,1,249,65.61C175.32,89,133.68,172.84,133.27,173.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.2,232.46H17.06V34.32H141.38a8.49,8.49,0,1,1,0,17H34V215.47H198.22V135.08a8.49,8.49,0,1,1,17,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedbox);
export default __webpack_public_path__ + "static/media/checkedbox.32f5e5f9111fbf10939bb51b34e23aec.svg";
export { ForwardRef as ReactComponent };